module.exports = __webpack_public_path__ + "img/start0_xs.3777fbd4.jpg";